/**
 * Unit Measurement reducer
 */
import { propertyExist } from 'utils/propertyValidation';
import {
  SET_NOTIFICATIONS_SETTINGS,
  SET_NOTIFICATION_PREFERENCES,
  SET_UNIT_MEASUREMENT,
  SET_NOTIFICATION_PREFERENCES_FAIL,
  SET_SITE_NOTIFICATIONS,
  FETCH_SITE_NOTIFICATIONS_FAIL,
  PATCH_SITE_NOTIFICATIONS,
  PATCH_SITE_NOTIFICATIONS_FAIL,
  SET_DARK_MODE,
  SET_ALARM_PREFERENCES_START,
  SET_ALARM_PREFERENCES,
  SET_ALARM_PREFERENCES_BATCH,
  REMOVE_ALARM_PREFERENCE_SITE,
  SET_ALARM_PREFERENCES_FAIL,
} from './types';

const initialState = {
  notifications: {},
  sites: [],
  alarmPreferencesBySiteId: {},
  alarmPreferencesSaving: false,
  alarmPreferencesError: null,
  alarmPreferencesLastSavedSiteId: null,
};
/**
 * settingsReducer
 * Update the states from notifications redux
 * @param {Object} state receives new state
 * @param {Object} action receives action data
 * @return {Object}
 */
const settingsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_NOTIFICATIONS_SETTINGS:
      return {
        ...state,
        notifications: {
          ...(action.payload || {}),
          darkMode: action.payload?.darkMode === true,
        },
        displayPlaceholder: false,
      };
    case SET_DARK_MODE:
      return {
        ...state,
        notifications: {
          ...(state.notifications || {}),
          darkMode: action.payload === true,
        },
      };
    case SET_NOTIFICATION_PREFERENCES_FAIL:
      return {
        ...state,
        notifications: null,
        displayPlaceholder: true,
      };
    case SET_NOTIFICATION_PREFERENCES:
      if (propertyExist(() => state.notifications.notificationPreferences)) {
        return {
          ...state,
          notifications: {
            ...state.notifications,
            notificationPreferences: state.notifications.notificationPreferences.map(
              (notification) =>
                notification.notificationPreferenceId === action.payload.notificationPreferenceId
                  ? action.payload
                  : notification,
            ),
          },
        };
      }
      return state;
    case SET_UNIT_MEASUREMENT:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          unitMeasurement: action.payload,
        },
      };
    case SET_SITE_NOTIFICATIONS:
      return {
        ...state,
        // eslint-disable-next-line func-names
        sites: action.payload.sort(function (a, b) {
          return a.siteName.localeCompare(b.siteName);
        }),
      };
    case FETCH_SITE_NOTIFICATIONS_FAIL:
      return {
        ...state,
        sites: [],
      };
    case PATCH_SITE_NOTIFICATIONS:
      return {
        ...state,
        sites: state.sites.map((site) =>
          site.siteId === action.payload[0].siteId ? action.payload[0] : site,
        ),
      };
    case PATCH_SITE_NOTIFICATIONS_FAIL:
      return state;
    case SET_ALARM_PREFERENCES_START:
      return {
        ...state,
        alarmPreferencesSaving: true,
        alarmPreferencesError: null,
      };
    case SET_ALARM_PREFERENCES:
      return {
        ...state,
        alarmPreferencesBySiteId: {
          ...state.alarmPreferencesBySiteId,
          [action.payload.siteId]: {
            subscribedCategories: action.payload.subscribedCategories,
            subscribedDevices: action.payload.subscribedDevices,
            enableSMS: action.payload.enableSMS,
            enableEmail: action.payload.enableEmail,
            enableBellNotification: action.payload.enableBellNotification,
          },
        },
        alarmPreferencesSaving: false,
        alarmPreferencesError: null,
        alarmPreferencesLastSavedSiteId: action.payload.siteId,
      };
    case SET_ALARM_PREFERENCES_BATCH: {
      const bySite = action.payload.reduce((accumulator, current) => {
        accumulator[current.siteId] = {
          subscribedCategories: current.subscribedCategories,
          subscribedDevices: current.subscribedDevices,
          enableSMS: current.enableSMS,
          enableEmail: current.enableEmail,
          enableBellNotification: current.enableBellNotification,
        };
        return accumulator;
      }, {});
      const lastSavedSiteId = action.payload[action.payload.length - 1]?.siteId || null;
      return {
        ...state,
        alarmPreferencesBySiteId: bySite,
        alarmPreferencesSaving: false,
        alarmPreferencesError: null,
        alarmPreferencesLastSavedSiteId: lastSavedSiteId,
      };
    }
    case REMOVE_ALARM_PREFERENCE_SITE: {
      const nextAlarmPreferencesBySiteId = { ...state.alarmPreferencesBySiteId };
      delete nextAlarmPreferencesBySiteId[action.payload];
      delete nextAlarmPreferencesBySiteId[`${action.payload}`];

      return {
        ...state,
        alarmPreferencesBySiteId: nextAlarmPreferencesBySiteId,
        alarmPreferencesSaving: false,
        alarmPreferencesError: null,
        alarmPreferencesLastSavedSiteId: action.payload,
      };
    }
    case SET_ALARM_PREFERENCES_FAIL:
      return {
        ...state,
        alarmPreferencesSaving: false,
        alarmPreferencesError: action.payload,
      };
    default:
      return state;
  }
};

export default settingsReducer;
